import { Loader2 } from 'lucide-react';
import { useAdminSystemHealth } from '../../hooks/useAdminApi';

export function AdminSystemPage() {
  const healthQuery = useAdminSystemHealth();

  if (healthQuery.isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-6 h-6 text-[#8b949e] animate-spin" />
      </div>
    );
  }

  const health = healthQuery.data;

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-[22px] font-semibold text-white">System</h1>
        <p className="text-[13px] text-[#8b949e]">Database health</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 mb-5">
        <div className="bg-[#161b22] border border-[#21262d] rounded-lg p-4">
          <div className="text-[#8b949e] text-[11px] uppercase tracking-wide mb-1">SCRAPELOG ROWS</div>
          <div className="text-2xl font-bold text-white">
            {(health?.rowCounts?.scrapeLog ?? 0).toLocaleString()}
          </div>
        </div>

        <div className="bg-[#161b22] border border-[#21262d] rounded-lg p-4">
          <div className="text-[#8b949e] text-[11px] uppercase tracking-wide mb-1">AVAILABILITY ROWS</div>
          <div className="text-2xl font-bold text-white">
            {(health?.rowCounts?.availability ?? 0).toLocaleString()}
          </div>
        </div>

        <div className="bg-[#161b22] border border-[#21262d] rounded-lg p-4">
          <div className="text-[#8b949e] text-[11px] uppercase tracking-wide mb-1">AVAILABILITYEVENT ROWS</div>
          <div className="text-2xl font-bold text-white">
            {(health?.rowCounts?.availabilityEvent ?? 0).toLocaleString()}
          </div>
        </div>
      </div>
    </div>
  );
}
